import { useStore } from 'zustand';
import { type SessionState, sessionStore } from '@/shared/api';

/** Lê o estado de sessão (em memória) de forma reativa. */
export function useSession<T>(selector: (state: SessionState) => T): T {
  return useStore(sessionStore, selector);
}
